import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

/**
 * Content Assistant chatbot API (proxied via api-hawk-v2 → ai-hawk-v1).
 */
export const chatbotApi = {
  createSession: (payload = {}) =>
    mod.post('/chat/sessions', payload),

  listSessions: (params) =>
    mod.get('/chat/sessions', { params }),

  getSession: (sessionId) =>
    mod.get(`/chat/sessions/${sessionId}`),

  deleteSession: (sessionId) =>
    mod.delete(`/chat/sessions/${sessionId}`),

  listMessages: (sessionId) =>
    mod.get(`/chat/sessions/${sessionId}/messages`),

  listArticles: (sessionId) =>
    mod.get(`/chat/sessions/${sessionId}/articles`),

  /**
   * Import free-form article text into the session.
   * @param {number} sessionId
   * @param {{ title: string; content: string; url?: string; dataroom_article_id?: number; raw_data_id?: number }} body
   */
  importArticle: (sessionId, body) =>
    mod.post(`/chat/sessions/${sessionId}/articles`, body, { timeout: 180000 }),

  /**
   * Import from shared DB by DataRoom id and/or raw_data_id.
   * @param {number} sessionId
   * @param {{ dataroom_article_id?: number; raw_data_id?: number }} body
   */
  importFromDataroom: (sessionId, body) =>
    mod.post(`/chat/sessions/${sessionId}/articles/from-dataroom`, body, {
      timeout: 180000,
    }),

  /**
   * Ask a question in the session (RAG + GPT).
   * @param {number} sessionId
   * @param {{ question: string }} body
   */
  ask: (sessionId, body) =>
    mod.post(`/chat/sessions/${sessionId}/ask`, body, { timeout: 120000 }),
};
